module.exports = __webpack_public_path__ + "static/media/spa.67cff855.svg";